import i18n from "~/lib/i18n";

export default function (app) {
  app.use(i18n);

  app.config.globalProperties.i18n = i18n;

  const { t } = i18n.global;

  app.directive("html-t", (el, binding) => {
    if (!binding.value) return;
    
    const tArgs =
      binding.value instanceof Array ? binding.value : [binding.value];
    el.innerHTML = t(...tArgs);
  });
}
